module.exports = __webpack_public_path__ + "static/media/grayscale.0ffea10e.jpg";